const VerticalLayout = () => import('@/layouts/VerticalLayout')


const HighCharts = () => import('./AmCharts')

export default [
  {
    path: '/amChart',
    name: 'amChart',
    component: VerticalLayout,
    meta: { auth: true },
    children: [{
      path: '',
      name: 'amChart',
      meta: { auth: true, name: 'amChart' },
      component: HighCharts
    }
    ]
  }

]
